var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReroad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-reroad",
    transform: "translate(0.164 0.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_45",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 45",
    transform: "translate(-0.412 -0.412)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_13",
    "data-name": "\\u9577\\u65B9\\u5F62 13",
    width: 32,
    height: 32,
    transform: "translate(0.248 0.248)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_48",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 48",
    transform: "translate(4.107 4.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_47",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_46",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_35",
    "data-name": "\\u30D1\\u30B9 35",
    d: "M27.961,13.78H19.124L22.695,10.1a9.174,9.174,0,0,0-12.877-.13,8.961,8.961,0,0,0,0,12.76,9.149,9.149,0,0,0,12.877,0,8.489,8.489,0,0,0,2.659-6.373h2.607a12.174,12.174,0,0,1-3.441,8.2,11.8,11.8,0,0,1-16.579,0,11.521,11.521,0,0,1-.026-16.4,11.714,11.714,0,0,1,16.487,0L27.961,4.5ZM16.882,11.017v5.539l4.562,2.711-.938,1.577-5.578-3.311V11.017Z",
    transform: "translate(-4.502 -4.5)",
    fill: "#5b87b4"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReroad);
export default __webpack_public_path__ + "static/media/icon-reroad.386d066e398c12e478a7220c85de2b06.svg";
export { ForwardRef as ReactComponent };